<template>
    <detalhe titulo="Status" :size="size">
        <status :status="participante?.statusVinculoPjPfDescr"></status>
    </detalhe>
    <detalhe titulo="Data Integração" :size="size">
        {{ $dateFormat(participante?.dataVinculoPjPf, 'DD/MM/YYYY HH:mm:ss') }}
    </detalhe>
    <detalhe titulo="Objeto Integração" :size="size">
        <vue-json-pretty
            :data="JSON.parse(participante?.objetoVinculoPjPf)"
            :showDoubleQuotes="true"
            v-if="participante?.objetoVinculoPjPf && participante?.objetoVinculoPjPf?.isJson()"
        ></vue-json-pretty>
        <span v-if="participante?.objetoVinculoPjPf && !participante?.objetoVinculoPjPf?.isJson()">{{ participante?.objetoVinculoPjPf }}</span>
    </detalhe>
    <detalhe titulo="Retorno Integração" :size="size">
        <vue-json-pretty
            :data="JSON.parse(participante?.objetoRetornoVinculoPjPf)"
            :showDoubleQuotes="true"
            v-if="participante?.objetoRetornoVinculoPjPf && participante?.objetoRetornoVinculoPjPf?.isJson()"
        ></vue-json-pretty>
        <span v-if="participante?.objetoRetornoVinculoPjPf && !participante?.objetoRetornoVinculoPjPf?.isJson()">
            {{ participante?.objetoRetornoVinculoPjPf }}</span
        >
    </detalhe>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

export default {
    components: {
        VueJsonPretty,
    },

    props: {
        participante: {
            type: Object,
        },
    },

    data() {
        return {
            size: '140',
        };
    },
};
</script>
